import type { IconName } from "@frontend/components/atoms/Icon";

/**
 * The API says what an entity is, never how to draw it. This is where the
 * front decides, with its own icon set.
 */
const entityIcons: Record<string, IconName> = {
  client: "Briefcase",
  employee: "Users",
  supplier: "ShoppingCart",
  subcontractor: "Puzzle",
  subscription: "Network",
  intervention: "Zap",
};

export function entityIcon(entity: string): IconName {
  return entityIcons[entity] ?? "Link2";
}
